import React from "react";
import { Link } from "react-router-dom";
import "./Cards.css";

export default function Cards({
  newCount,
  prelimCount,
  completedCount,
  orderLink,
}) {
  return (
    <>
      <div className="cards">
        <div className="cards-head">
          <div className="cards-title h5">Orders</div>
        </div>
        <div className="cards-body">
          <div className="cards-text">
            <div className="cards-list-group">
              <div className="cards-list-item">
                <span className="text-blue">New:</span> {newCount}
              </div>
              <div className="cards-list-item">
                <span className="text-gray">Prelim:</span> {prelimCount}
              </div>
              <div className="cards-list-item">
                <span className="text-sky">Completed:</span> {completedCount}
              </div>
            </div>
          </div>
        </div>
        <Link to={orderLink} className="cards-link">
          View All Orders
        </Link>
      </div>
    </>
  );
}
